"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var categoryApi = _interopRequireWildcard(require("@/api/categoryApi.js"));
var storeApi = _interopRequireWildcard(require("@/api/store"));
var jdStoreApi = _interopRequireWildcard(require("@/api/jdStoreApi.js"));
var samStoreApi = _interopRequireWildcard(require("@/api/samStoreApi.js"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _companyappApi = require("@/api/companyappApi");
var _marketing = require("@/api/marketing");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  props: {
    pageType: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      visible: false,
      submitting: false,
      pram: {
        strategyType: 1,
        appScope: 0,
        companyAppIds: [],
        status: 0,
        sort: 0,
        isPermanently: 1,
        effectiveTime: []
      },
      appOptions: [],
      effectiveTimePickerOptions: {},
      effectiveTimeDefaultRange: ['00:00:00', '23:59:59'],
      rules: {
        strategyName: [{
          required: true,
          message: '请输入策略名称',
          trigger: 'blur'
        }, {
          max: 20,
          message: '策略名称不能超过20个字符',
          trigger: 'blur'
        }],
        effectiveTime: [{
          validator: this.validateEffectiveTime,
          trigger: 'change'
        }]
      },
      editIdx: 0,
      tagOption: [],
      jdCateIdsOption: [],
      // 京东商品分类
      cateIdsOption: [],
      // 商品分类
      brandOption: [],
      GOODS_TYPE_MAP: [{
        name: '自营商品',
        key: 1
      }, {
        name: '来一票京东',
        key: 80
      }],
      LYP_SORT_OPTIONS: [{
        key: 1,
        label: '销量降序'
      }, {
        key: 2,
        label: '价格升序（会出现价格过低商品，且个别价格低商品无法下单）'
      }, {
        key: 3,
        label: '价格降序'
      }, {
        key: 4,
        label: '评论数降序'
      }, {
        key: 5,
        label: '上架时间降序'
      }, {
        key: 6,
        label: '15天销售额降序'
      }]
    };
  },
  computed: {
    filteredGoodsTypeMap: function filteredGoodsTypeMap() {
      return this.GOODS_TYPE_MAP;
    },
    isEdit: function isEdit() {
      return this.editIdx === 1;
    }
  },
  methods: {
    throttle: _throttle.default,
    openInit: function openInit(editIdx) {
      var row = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var strategy = row.strategy || row;
      var strategyDesigns = row.strategyDesigns || [];
      var targetType = strategyDesigns.length ? Number(strategyDesigns[0].targetType) : null;
      var targetIds = strategyDesigns.map(function (item) {
        return Number(item.targetId);
      }).filter(Boolean);
      var goodsTypeMap = {
        1: 1,
        2: 5,
        3: 3
      };
      var bindMethodGoodsTypeMap = {
        1: 1,
        2: 3,
        3: 5
      };
      var rowGoodsType = strategy.bindMethod != null && Number(strategy.bindMethod) !== 0 ? bindMethodGoodsTypeMap[Number(strategy.bindMethod)] : strategy.goodsType != null ? strategy.goodsType : goodsTypeMap[targetType] || strategy.type || 1;
      this.pram = _objectSpread(_objectSpread({
        isCheap: 1
      }, strategy), {}, {
        goodsType: rowGoodsType,
        strategyType: strategy.strategyType != null ? Number(strategy.strategyType) : 1,
        appScope: strategy.appScope != null ? Number(strategy.appScope) : 0,
        companyAppIds: row.strategyApps ? row.strategyApps.map(function (item) {
          return Number(item.companyAppId);
        }) : strategy.companyAppIds || [],
        status: strategy.status != null ? Number(strategy.status) : 0,
        sort: strategy.sort != null ? Number(strategy.sort) : 0,
        isPermanently: strategy.isPermanently != null ? Number(strategy.isPermanently) : 1,
        effectiveTime: Number(strategy.isPermanently) === 0 && strategy.startTime && strategy.endTime ? [strategy.startTime, strategy.endTime] : [],
        targetIds: targetIds,
        showCateId: targetType === 1 ? targetIds.map(function (id) {
          return [id];
        }) : [],
        skuId: targetType === 3 ? targetIds.join(',') : '',
        spuId: targetType === 2 ? targetIds.join(',') : '',
        lypSortType: strategy.lypSortOption != null ? Number(strategy.lypSortOption) : 1
      });
      this.getCate(this.pram.strategyType);
      this.getAppOptions();
      this.resetEffectiveTimePickerOptions();
      this.editIdx = editIdx;
      this.visible = true;
    },
    saveEdit: function saveEdit() {
      var _this = this;
      this.$refs.pram.validate(function (valid) {
        if (!valid) return;
        if (!_this.validateTargetInputFormat()) {
          _this.$message.error('输入不合法');
          return;
        }
        var data = _this.buildSubmitParams();
        _this.checkTargetBeforeSubmit(data);
      });
    },
    checkTargetBeforeSubmit: function checkTargetBeforeSubmit(data) {
      var _this2 = this;
      if (data.strategyType === 80) {
        if (data.status === 1) {
          this.checkLypAppBeforeSubmit(data);
        } else {
          this.submitSave(data);
        }
        return;
      }
      if (![2, 3].includes(data.targetType) || !data.targetIds.length) {
        this.submitSave(data);
        return;
      }
      this.submitting = true;
      (0, _marketing.cartRecommendStrategyCheckTargetApi)({
        targetType: data.targetType,
        targetIds: data.targetIds
      }).then(function (res) {
        var result = res && res.data || res || {};
        var notExistIds = result.notExistIds || [];
        var notDisplayIds = result.notDisplayIds || [];
        var targetLabel = data.targetType === 2 ? 'spuId' : 'skuId';
        if (!notExistIds.length && !notDisplayIds.length) {
          _this2.checkPriorityBeforeSubmit(data);
          return;
        }
        _this2.submitting = false;
        var messages = [];
        if (notExistIds.length) {
          messages.push("\u5546\u54C1".concat(targetLabel, "[").concat(notExistIds.join(','), "]\u4E0D\u5B58\u5728"));
        }
        if (notDisplayIds.length) {
          messages.push("\u5546\u54C1".concat(targetLabel, "[").concat(notDisplayIds.join(','), "]\u4E3A\u975E\u81EA\u8425\u5546\u54C1"));
        }
        if (result.allInvalid) {
          _this2.$alert("".concat(messages.join('，'), "\uFF0C\u4E0D\u5141\u8BB8\u4FDD\u5B58"), '提示', {
            confirmButtonText: '知道了',
            type: 'warning'
          });
          return;
        }
        messages.push("\u521B\u5EFA\u540E\u4E0D\u751F\u6548");
        _this2.$confirm("".concat(messages.join('，'), "\uFF0C\u786E\u8BA4\u8981\u4FDD\u5B58\uFF1F"), '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this2.checkPriorityBeforeSubmit(data);
        }).catch(function () {});
      }).catch(function () {
        _this2.submitting = false;
      });
    },
    checkLypAppBeforeSubmit: function checkLypAppBeforeSubmit(data) {
      var _this3 = this;
      this.submitting = true;
      (0, _marketing.cartRecommendStrategyCheckLypAppApi)({
        id: this.isEdit ? data.id : null,
        appScope: data.appScope,
        companyAppIds: data.companyAppIds
      }).then(function (res) {
        var result = res && res.data || res || {};
        var conflicts = result.conflicts || [];
        if (!conflicts.length) {
          _this3.submitSave(data);
          return;
        }
        _this3.submitting = false;
        if (data.appScope === 0) {
          _this3.$alert("\u5DF2\u5B58\u5728\u5168\u90E8\u5C0F\u7A0B\u5E8F\u7684\u6765\u4E00\u7968\u4EAC\u4E1C\u5F00\u542F\u7684\u7B56\u7565\u3010".concat(conflicts[0].strategyName, "\u3011\uFF0C\u4E0D\u5141\u8BB8\u4FDD\u5B58"), '提示', {
            confirmButtonText: '知道了',
            type: 'warning'
          });
          return;
        }
        var messages = conflicts.map(function (item) {
          return "\u3010".concat(item.companyAppName, "\u3011\u5DF2\u5728\u3010").concat(item.strategyName, "\u3011\u4E2D\u5F00\u542F\u7B56\u7565");
        });
        if (result.allConflict) {
          _this3.$alert("".concat(messages.join('，'), "\uFF0C\u6240\u6709\u63D0\u4EA4\u7684\u5C0F\u7A0B\u5E8F\u5747\u5DF2\u5B58\u5728\u6765\u4E00\u7968\u4EAC\u4E1C\u7B56\u7565\uFF0C\u4E0D\u5141\u8BB8\u4FDD\u5B58"), '提示', {
            confirmButtonText: '知道了',
            type: 'warning'
          });
          return;
        }
        _this3.$confirm("".concat(messages.join('，'), "\uFF0C\u521B\u5EFA\u65F6\u5C06\u8DF3\u8FC7\u8BE5\u5C0F\u7A0B\u5E8F\uFF0C\u662F\u5426\u7EE7\u7EED\u521B\u5EFA\uFF1F"), '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this3.submitSave(data);
        }).catch(function () {});
      }).catch(function () {
        _this3.submitting = false;
      });
    },
    checkPriorityBeforeSubmit: function checkPriorityBeforeSubmit(data) {
      var _this4 = this;
      this.submitting = true;
      (0, _marketing.cartRecommendStrategyCheckPriorityApi)({
        id: this.isEdit ? data.id : null,
        sort: data.sort,
        targetType: data.targetType,
        targetIds: data.targetIds
      }).then(function (res) {
        var conflicts = Array.isArray(res) ? res : res && res.data || [];
        if (!conflicts.length) {
          _this4.submitSave(data);
          return;
        }
        _this4.submitting = false;
        var conflictMessages = conflicts.map(function (item) {
          return "\u5546\u54C1\u3010".concat(item.targetId, "\u3011\u5DF2\u5B58\u5728\u4E8E\u7B56\u7565\u3010").concat(item.strategyName, "\u3011");
        });
        _this4.$confirm("".concat(conflictMessages.join('，'), "\u3002\u5F53\u524D\u7B56\u7565\u4F18\u5148\u7EA7\u8F83\u4F4E\uFF0C\u8BE5\u5546\u54C1\u5C06\u88AB\u9AD8\u4F18\u5148\u7EA7\u7B56\u7565\u8986\u76D6\u4E0D\u4F1A\u751F\u6548\uFF0C\u662F\u5426\u4ECD\u8981\u4FDD\u5B58\uFF1F"), '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this4.submitSave(data);
        }).catch(function () {});
      }).catch(function () {
        _this4.submitting = false;
      });
    },
    submitSave: function submitSave(data) {
      var _this5 = this;
      this.submitting = true;
      var requestApi = this.isEdit ? _marketing.cartRecommendStrategyUpdateApi : _marketing.cartRecommendStrategyAddApi;
      requestApi(data).then(function () {
        _this5.$message.success(_this5.isEdit ? '编辑成功' : '新增成功');
        _this5.visible = false;
        _this5.$emit('doRefresh');
      }).finally(function () {
        _this5.submitting = false;
      });
    },
    validateTargetInputFormat: function validateTargetInputFormat() {
      if (this.pram.strategyType !== 1) return true;
      if (![3, 5].includes(this.pram.goodsType)) return true;
      var rawValue = this.pram.goodsType === 3 ? this.pram.skuId : this.pram.spuId;
      var text = String(rawValue || '').trim();
      if (!text) return true;
      return /^\d+(,\d+)*$/.test(text);
    },
    validateTargetContent: function validateTargetContent(rule, value, callback) {
      if (Number(this.pram.strategyType) !== 1) {
        callback();
        return;
      }
      var hasContent = false;
      if (Number(this.pram.goodsType) === 1) {
        hasContent = Array.isArray(this.pram.showCateId) && this.pram.showCateId.length > 0;
      } else if (Number(this.pram.goodsType) === 3) {
        hasContent = Boolean(String(this.pram.skuId || '').trim());
      } else if (Number(this.pram.goodsType) === 5) {
        hasContent = Boolean(String(this.pram.spuId || '').trim());
      }
      if (!hasContent) {
        callback(new Error('请选择或输入绑定内容'));
        return;
      }
      callback();
    },
    buildSubmitParams: function buildSubmitParams() {
      var strategyType = Number(this.pram.strategyType);
      var targetTypeMap = {
        1: 1,
        3: 3,
        5: 2
      };
      var bindMethodMap = {
        1: 1,
        3: 2,
        5: 3
      };
      var targetIds = strategyType === 1 ? this.getTargetIds() : [];
      var isPermanently = Number(this.pram.isPermanently);
      var _ref = isPermanently === 0 ? this.pram.effectiveTime : [],
        _ref2 = _slicedToArray(_ref, 2),
        startTime = _ref2[0],
        endTime = _ref2[1];
      var data = {
        strategyName: (this.pram.strategyName || '').trim(),
        isPermanently: isPermanently,
        startTime: isPermanently === 0 ? startTime : null,
        endTime: isPermanently === 0 ? endTime : null,
        appScope: Number(this.pram.appScope),
        companyAppIds: this.pram.appScope === 1 ? this.pram.companyAppIds.map(function (id) {
          return Number(id);
        }) : [],
        status: Number(this.pram.status),
        sort: Number(this.pram.sort),
        strategyType: strategyType,
        bindMethod: strategyType === 1 ? bindMethodMap[this.pram.goodsType] : 0,
        targetType: strategyType === 1 ? targetTypeMap[this.pram.goodsType] : null,
        targetIds: targetIds
      };
      if (this.isEdit) data.id = Number(this.pram.id);
      if (strategyType === 80) {
        data.lypSortOption = Number(this.pram.lypSortType);
      }
      return data;
    },
    getTargetIds: function getTargetIds() {
      if (this.pram.goodsType === 1) {
        return (this.pram.showCateId || []).map(function (item) {
          var value = Array.isArray(item) ? item[item.length - 1] : item;
          return Number(value);
        }).filter(Boolean);
      }
      if (this.pram.goodsType === 3) {
        return this.splitTargetValues(this.pram.skuId);
      }
      if (this.pram.goodsType === 5) {
        return this.splitTargetValues(this.pram.spuId);
      }
      return [];
    },
    splitTargetValues: function splitTargetValues(value) {
      return String(value || '').split(',').map(function (item) {
        return Number(item.trim());
      }).filter(Boolean);
    },
    validateEffectiveTime: function validateEffectiveTime(rule, value, callback) {
      if (this.pram.isPermanently === 0 && (!Array.isArray(value) || !value[0] || !value[1])) {
        callback(new Error('请选择完整的开始时间和结束时间'));
        return;
      }
      callback();
    },
    resetEffectiveTimePickerOptions: function resetEffectiveTimePickerOptions() {
      var formatDateTime = function formatDateTime(date) {
        var pad = function pad(value) {
          return String(value).padStart(2, '0');
        };
        return "".concat(date.getFullYear(), "-").concat(pad(date.getMonth() + 1), "-").concat(pad(date.getDate()), " ").concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()), ":").concat(pad(date.getSeconds()));
      };
      var now = new Date();
      var end = new Date(2099, 11, 31, 23, 59, 59);
      this.effectiveTimePickerOptions = {
        disabledDate: function disabledDate(time) {
          var selectedDay = new Date(time.getFullYear(), time.getMonth(), time.getDate());
          var today = new Date();
          today.setHours(0, 0, 0, 0);
          return selectedDay.getTime() < today.getTime();
        },
        selectableRange: "".concat(formatDateTime(now), " - ").concat(formatDateTime(end))
      };
    },
    onEffectiveTimePickerVisible: function onEffectiveTimePickerVisible(visible) {
      if (visible) this.resetEffectiveTimePickerOptions();
    },
    onEffectiveTimeChange: function onEffectiveTimeChange(value) {
      if (!Array.isArray(value) || !value[0] || !value[1]) return;
      var start = new Date(String(value[0]).replace(/-/g, '/'));
      var end = new Date(String(value[1]).replace(/-/g, '/'));
      if (start.getTime() > end.getTime()) {
        this.pram.effectiveTime = [value[0], value[0]];
      }
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    validateCompanyAppIds: function validateCompanyAppIds(rule, value, callback) {
      if (this.pram.appScope === 1 && (!value || !value.length)) {
        callback(new Error('请选择小程序'));
        return;
      }
      callback();
    },
    getAppOptions: function getAppOptions() {
      var _this6 = this;
      (0, _companyappApi.companyappAutoListApi)().then(function (res) {
        _this6.appOptions = (res || []).map(function (item) {
          return {
            label: item.appName,
            value: item.id
          };
        });
      });
    },
    changeSourceType: function changeSourceType() {
      var _this$pram, _this$pram2, _this$pram3;
      var _ref3 = this.pram || {},
        strategyType = _ref3.strategyType,
        goodsType = _ref3.goodsType;
      (_this$pram = this.pram) === null || _this$pram === void 0 ? true : delete _this$pram.skuId;
      (_this$pram2 = this.pram) === null || _this$pram2 === void 0 ? true : delete _this$pram2.labelId;
      (_this$pram3 = this.pram) === null || _this$pram3 === void 0 ? true : delete _this$pram3.showCateId;
      this.getCate(strategyType);
      if (strategyType !== 80) {
        this.$delete(this.pram, 'lypSortType');
      } else {
        var st = Number(this.pram.lypSortType);
        if (![1, 2, 3, 4, 5, 6].includes(st)) {
          this.$set(this.pram, 'lypSortType', 1);
        }
      }
      if (strategyType === 80 && ![1, 3].includes(goodsType)) {
        this.pram.goodsType = 1;
      }
    },
    getCate: function getCate(strategyType) {
      var _this7 = this;
      this.jdCateIdsOption = [];
      categoryApi.jdCateLists().then(function (res) {
        _this7.jdCateIdsOption = res;
      });
      this.cateIdsOption = [];
      if (strategyType === 80) {
        var req = strategyType === 80 ? jdStoreApi.getJdCategoryList : samStoreApi.getSamCategoryList;
        req({
          status: 1
        }).then(function (res) {
          _this7.cateIdsOption = Array.isArray(res) ? res : res && res.data || [];
        }).catch(function () {
          _this7.cateIdsOption = [];
        });
        return;
      }
      storeApi.categoryApi({
        status: -1,
        type: 8
      }).then(function (res) {
        _this7.cateIdsOption = _this7.addDisabled(res);
        _this7.restoreCategoryPaths();
      });
    },
    restoreCategoryPaths: function restoreCategoryPaths() {
      var _this8 = this;
      if (this.pram.goodsType !== 1 || !this.pram.targetIds || !this.pram.targetIds.length) return;
      var _findPath = function findPath(list, targetId) {
        var parentPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var _iterator = _createForOfIteratorHelper(list || []),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            var currentPath = [].concat(_toConsumableArray(parentPath), [item.id]);
            if (Number(item.id) === Number(targetId)) return currentPath;
            var result = _findPath(item.child, targetId, currentPath);
            if (result) return result;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return null;
      };
      var paths = this.pram.targetIds.map(function (id) {
        return _findPath(_this8.cateIdsOption, id);
      }).filter(Boolean);
      if (paths.length) this.pram.showCateId = paths;
    },
    addDisabled: function addDisabled() {
      var _this9 = this;
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var list = [];
      arr && arr.length && arr.forEach(function (e, index) {
        var e_new = _objectSpread(_objectSpread({}, e), {}, {
          disabled: !e.status
        });
        if (e.child) {
          var childList = _this9.addDisabled(e.child);
          e_new = _objectSpread(_objectSpread({}, e_new), {}, {
            child: childList
          });
        }
        list.push(e_new);
      });
      return list;
    }
  }
};